// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 股票指标试用服务信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /quote-index/subscription/info */
export async function quoteIndexSubscriptionInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.quoteIndexSubscriptionInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultQuoteIndexSubscriptionInfoResp>('/quote-index/subscription/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票指标试用 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /quote-index/subscription/open */
export async function quoteIndexSubscriptionOpenUsingPOST(
  body: API.QuoteIndexSubscriptionOpenReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/quote-index/subscription/open', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
